import {
    METRICS_ERROR,
    GET_METRICS,
    SET_METRICS,
    UPDATE_METRIC,
  } from "./actionTypes";
  
  export const metricsError = (error) => {
    return {
      type: METRICS_ERROR,
      payload: error,
    }
  }
  
  export const getMetrics = () => {
    return {
      type: GET_METRICS,
      payload: {},
    }
  }
  export const setMetrics = (data) => {
    return {
      type: SET_METRICS,
      payload: data,
    }
  }

  export const updateMetric = (data) => {
    return {
      type: UPDATE_METRIC,
      payload: data,
    }
  }
  